/**
 * Usage Configuration for Supplies
 */

import { supabase } from '../../../../../supabaseClient';

export const usageSupplyConfig = {
  type: 'supplies',
  displayName: 'Supplies',
  singularName: 'Supply',
  itemIdField: 'supply_id',
  itemNameField: 'name',
  
  // Database tables
  inventoryTable: 'supply_inventory',
  itemsTable: 'supply_inventory_items',
  transactionsTable: 'supply_transactions',
  
  // Get available inventory items for a location
  getInventoryItems: async (companyId, itemId, locationId) => {
    const { data, error } = await supabase
      .from('supply_inventory_items')
      .select('*')
      .eq('company_id', companyId)
      .eq('supply_id', itemId)
      .eq('location_id', locationId)
      .eq('is_active', true)
      .gt('current_quantity', 0)
      .order('created_at', { ascending: true });
    
    if (error) throw error;
    return data || [];
  },
  
  // Execute usage transaction
  executeUsage: async (companyId, usageData) => {
    const { locationId, usages, notes } = usageData;
    
    // Process each usage item
    for (const usage of usages) {
      const { itemId, lotId, quantity, lot_number, batch_number } = usage;
      
      // Only create transaction - DB triggers will handle inventory updates
      const { error: txError } = await supabase
        .from('supply_transactions')
        .insert([{
          company_id: companyId,
          supply_id: itemId,
          transaction_type: 'usage',
          quantity: -Math.abs(quantity), // Negative for usage
          location_id: locationId,
          lot_number: lot_number,
          batch_number: batch_number,
          transaction_date: new Date().toISOString(),
          notes: notes || null,
          delivery_status: 'delivered'
        }]);
      
      if (txError) throw txError;
    }
  }
};
